import { types as sdkTypes } from '../util/sdkLoader';

const { LatLng, LatLngBounds } = sdkTypes;

const getLocaleFromLocalStorage = () => {
  if (typeof window === 'undefined') return 'en';
  return window.localStorage.getItem('locale') || 'en';
};

const normalizeLocale = locale => (locale || 'en').toLowerCase() === 'th' ? 'th' : 'en';

const getLocalizedAddress = (en, th) => {
  const locale = normalizeLocale(getLocaleFromLocalStorage());
  return locale === 'th' ? th : en;
};

// Default locations shown when user focuses location input
const defaultLocations = [
  {
    id: 'default-bangkok',
    predictionPlace: {
      address: getLocalizedAddress('Bangkok, Thailand', 'กรุงเทพมหานคร, ประเทศไทย'),
      bounds: new LatLngBounds(new LatLng(13.957, 100.728), new LatLng(13.528, 100.327)),
    },
  },
  {
    id: 'default-chiangmai',
    predictionPlace: {
      address: getLocalizedAddress('Chiang Mai, Thailand', 'เชียงใหม่, ประเทศไทย'),
      bounds: new LatLngBounds(new LatLng(19.001, 99.123), new LatLng(18.669, 98.878)),
    },
  },
  {
    id: 'default-phuket',
    predictionPlace: {
      address: getLocalizedAddress('Phuket, Thailand', 'ภูเก็ต, ประเทศไทย'),
      bounds: new LatLngBounds(new LatLng(8.191, 98.398), new LatLng(7.726, 98.246)),
    },
  },
  {
    id: 'default-pattaya',
    predictionPlace: {
      address: getLocalizedAddress('Pattaya, Thailand', 'พัทยา, ประเทศไทย'),
      bounds: new LatLngBounds(new LatLng(13.005, 100.956), new LatLng(12.85, 100.869)),
    },
  },
  {
    id: 'default-krabi',
    predictionPlace: {
      address: getLocalizedAddress('Krabi, Thailand', 'กระบี่, ประเทศไทย'),
      bounds: new LatLngBounds(new LatLng(8.198, 98.925), new LatLng(7.719, 98.779)),
    },
  },
];

export default defaultLocations;
